export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1024w.6fececdc.avif";